/**
 * RESPONSIBILITY: the Children's Ministry page's questions band.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, List } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { Faq } from './rows/faq';

@Section({ name: SectionName.ChildrenFaq, label: 'Children — questions' })
export class ChildrenFaqSection {
  @Text({ label: 'Title', maxLength: 120, default: 'What to expect' })
  faqHeading!: string;

  @List({ label: 'Questions', of: () => Faq, maxItems: 20 })
  faq!: Faq[];
}
